import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m9.812 3.45-.82.77-.821-.77c-1.692-1.595-3.703-1.595-5.395 0-1.701 1.587-1.701 4.175 0 5.761L9 15.75l6.224-6.539c1.701-1.594 1.701-4.174 0-5.77-1.7-1.594-3.711-1.586-5.412.009Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }